import { render, staticRenderFns } from "./SettingsHome.vue?vue&type=template&id=178868e0&scoped=true"
import script from "./SettingsHome.vue?vue&type=script&lang=js"
export * from "./SettingsHome.vue?vue&type=script&lang=js"
import style0 from "./SettingsHome.vue?vue&type=style&index=0&id=178868e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178868e0",
  null
  
)

export default component.exports